import { render, staticRenderFns } from "./GrupoUsuarioTabela.vue?vue&type=template&id=62c590df&scoped=true&"
import script from "./GrupoUsuarioTabela.vue?vue&type=script&lang=js&"
export * from "./GrupoUsuarioTabela.vue?vue&type=script&lang=js&"
import style0 from "./GrupoUsuarioTabela.vue?vue&type=style&index=0&id=62c590df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c590df",
  null
  
)

export default component.exports